module.exports = [{
      plugin: require('../node_modules/gatsby-omni-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"enableListener":true,"preconnect":["https://fonts.googleapis.com","https://fonts.gstatic.com"],"web":[{"name":"Oxygen","file":"https://fonts.googleapis.com/css2?family=Oxygen:wght@400;700&display=swap"},{"name":"Source Code Pro","file":"https://fonts.googleapis.com/css2?family=Source+Code+Pro:wght@400;500;600&display=swap"}]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
